import { IObject } from "@entities/api/object";
import type { IUpdateObject } from "@entities/object";
import { FormType } from "../../types/form-type.ts";
import { getDocumentationExaminations } from "./utils/get-documentation-examinations";
import { getDocumentationPermissions } from "./utils/get-documentation-permissions";

export function formToObjectMapper(
  data: FormType,
  orig: IObject,
): Omit<IUpdateObject, "type" | "buildingObjectId"> {
  // @ts-expect-error it just works
  const [documentationPermissions, permissions] = getDocumentationPermissions(
    data,
    orig,
  );

  // @ts-expect-error it just works
  const [documentationExaminations, examinations] =
    getDocumentationExaminations(data, orig);

  return {
    updateBuildingObjectRequest: {
      shortName: data.shortName,
      fullName: data.fullName,
      descriptionProjects: data.descriptionProjects,
      // @ts-expect-error null
      descriptionStage: data.descriptionStage,
      constructionType: data.constructionType,
      buildingStart: data.buildingStart.format("YYYY-MM-DD"),
      buildingEnd: data.buildingEnd.format("YYYY-MM-DD"),
      // @ts-expect-error null
      address: orig.address,
    },
    documentationPermissions,
    documentationExaminations,
    permissions,
    examinations,
    // documentationPermissions,
    // documentationExaminations,
  };
}
